/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable dot-notation */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
import { useEffect, useCallback, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Clock from '@utils/Clock';
import Cookies from '@utils/cookies';
import uaAnalytics from '@utils/uaAnalytics';
import { localStorageAvailable } from '@utils/localStorage';
import { useRouter } from 'next/router';
import { sessionStates } from '@constants/index';
import Player from './Player';
import UnLive from './UnLive';

const CoursePageIframe = styled.div`
  position: fixed;
  bottom: -100vh;
  height: 100vh;
  width: 100vw;
  z-index: 3;
  left: 0;
  transition: bottom 0.3s ease-in;
  will-change: auto;
  &.show-loader {
    will-change: bottom;
    transition: bottom 0.3s ease-in 0s;
    bottom: 0;
  }
`;

const player = new Player();
const clock = new Clock();
const viewer = new UnLive();

const VideoFrame = ({
  classDetails,
  loggedInUser,
  accessToken,
  isFullScreen,
  sendWatched,
  sendWatchedPrevious,
  streamUrl,
  showPlayer,
  isUnacademyTeachClass,
  reloadState,
  sendSubCardEvents,
  setSendSubCardEvents
}) => {
  // const dispatch = useDispatchToStore();
  player.connectWithDispatch();
  const router = useRouter();

  const [explicitJWTToken, setExplicitJWTToken] = useState('');
  const [isExternal, setIsExternal] = useState(false);

  if (sendSubCardEvents.subscriptionCardVisibleOnIframe) {
    player.sendSubscriptionCardVisibleEventOnIframe();
    setSendSubCardEvents({
      ...sendSubCardEvents,
      subscriptionCardVisibleOnIframe: false
    });
  }

  if (sendSubCardEvents.getSubscriptionClickedOnIframe) {
    player.sendSubscriptionClickedOnIframe();
    setSendSubCardEvents({
      ...sendSubCardEvents,
      getSubscriptionClickedOnIframe: false
    });
  }

  const getUpdatedKeysForIframe = () => {
    const classDetailsUpdated = { ...classDetails };
    classDetailsUpdated['video_duration'] = classDetails.lessonDuration;
    if (classDetails['author']) {
      classDetailsUpdated['author']['first_name'] =
        classDetails.author.firstName;
      classDetailsUpdated['author']['last_name'] = classDetails.author.lastName;
      classDetailsUpdated['author']['avatar'] = classDetails.author.thumbnail;
    }
    classDetailsUpdated['seconds_before_live'] = classDetails.secondsBeforeLive;
    classDetailsUpdated['started_at'] = classDetails.startedAt;
    classDetailsUpdated['live_at'] = classDetails.liveAt;
    classDetailsUpdated['is_special'] = classDetails.programme
      ? classDetails.programme.isSpecial
      : classDetails.isSpecial;
    classDetailsUpdated['created_at'] = classDetails.createdAt;
    classDetailsUpdated['watch_time'] = classDetails.watchTime;
    return classDetailsUpdated;
  };

  const sendClassData = () => {
    const classDetailsData = getUpdatedKeysForIframe();
    const isDarkModeOn = Cookies.readCookie('isDarkModeOn') || false;
    const classRoomLearnerName = localStorageAvailable()
      ? localStorage.getItem('classRoomLearnerName')
      : {};
    if (classDetails.videoUrl && classDetails.state === sessionStates.PAST)
      document.getElementById('nativeIframeOne')?.contentWindow?.postMessage(
        {
          lessonData: {
            accessToken,
            data: classDetailsData,
            replay: 'true',
            role: 'listener',
            url: classDetailsData.videoUrl,
            showBackButton: true,
            user_name: isUnacademyTeachClass ? classRoomLearnerName : '',
            explicitJWTToken,
            isExternal
          },
          isDarkModeOn,
          apiHost: process.env.BACKEND_URL.slice(0, -1)
        },
        '*'
      );
    else
      document.getElementById('nativeIframeOne')?.contentWindow?.postMessage(
        {
          lessonData: {
            accessToken,
            data: classDetailsData,
            showBackButton: true,
            role: 'listener',
            user_name: isUnacademyTeachClass ? classRoomLearnerName : '',
            explicitJWTToken,
            isExternal
          },
          isDarkModeOn,
          apiHost: process.env.BACKEND_URL.slice(0, -1)
        },
        '*'
      );
  };

  const setWatchTime = () => {
    player.totalWatchTime = localStorageAvailable()
      ? localStorage.getItem(`liveSessions[${classDetails.uid}]`)
      : 0;
    clock.setSeconds(player.totalWatchTime);
    player.setupFlags();
  };

  const setSecondsWatched = (seconds) => {
    player.totalWatchTime = seconds;
    if (localStorageAvailable())
      localStorage.setItem(
        `liveSessions[${classDetails.uid}]`,
        player.totalWatchTime
      );

    player.sendUaWatch();
    player.sendSV();
    player.sendSVFifteenMins();
    player.sendCurrentWatch(sendWatched);
    player.sendLessonWatched(sendWatchedPrevious);
  };

  const onStart = () => {
    clock.totalSeconds += 1;
    setSecondsWatched(clock.totalSeconds);
  };

  const setupForUa = () => {
    player.watchEvent = {};
    player.prevUACallTime = 0;
    clock.end();
    player.watchEvent.BROWSER_ID = Cookies.readCookie('BROWSER_ID')
      ? Cookies.readCookie('BROWSER_ID')
      : uaAnalytics.setBrowserId();
    player.watchEvent.PLAYER_ID = uaAnalytics.setPlayerId();
  };

  const setViewer = () => {
    viewer.addListener('finished', () => {
      clock.end();
    });
    viewer.addListener(
      'WATCHED',
      (evtName, isPlaying, data, isReplay, isLiveDvr, isLive) => {
        player.playedDuration = data;
        player.dvr = isLiveDvr;
        player.replay = isReplay;
        player.isLive = isLive;
      }
    );
    viewer.addListener(
      'UPDATE_CLASS_START_TIME',
      (evtName, isPlaying, data, isReplay, isLiveDvr, isLive) => {
        player.classStartTime = data;
        player.dvr = isLiveDvr;
        player.replay = isReplay;
        player.isLive = isLive;
      }
    );
    viewer.addListener('playing', (evtName, playing) => {
      if (playing) {
        if (!clock.started) {
          clock.start(onStart);
        } else {
          clock.resume(onStart);
        }
      } else {
        clock.pause();
      }
    });
  };

  const sendStartAnimationMessage = () => {
    document.getElementById('nativeIframeOne')?.contentWindow?.postMessage(
      {
        iframeMoved: true
      },
      '*'
    );
  };

  const onLoadHandler = () => {
    // precautionary cleanups
    viewer.cleanup();
    player.unmount();
    clock.end();

    // player/clock instance already there, reset them with new data
    player.setup(classDetails, loggedInUser);
    clock.setup(player.totalWatchTime);
    viewer.setup(isExternal);

    // sequence methods
    sendStartAnimationMessage();
    sendClassData();
    setWatchTime();
    setViewer();
    setupForUa();
  };

  const unmountStuff = () => {
    if (viewer) {
      viewer.cleanup();
    }
    if (clock) {
      clock.end();
    }
    if (player) {
      player.unmount();
    }
  };

  useEffect(() => {
    return () => {
      unmountStuff();
    };
  }, []);

  useEffect(() => {
    showPlayer ? onLoadHandler() : unmountStuff();
  }, [showPlayer]);

  const renderIframe = useCallback(() => {
    let finalUrl = streamUrl;
    /**
     * For testing with any clx build version
     */
    const clxVersionParam = router.query?.['clxVersion'];

    const jwtToken = router.query?.['ext_token'];
    setExplicitJWTToken(jwtToken);

    const external = router.query?.['external']
      ? router.query?.['external'] === '1'
      : false;
    setIsExternal(external);

    if (clxVersionParam) {
      // eslint-disable-next-line no-unused-vars
      finalUrl = finalUrl.replace(/\/v+\d*/, `/v${clxVersionParam}`);
    }
    /**
     * Replacing location so that on browser back, iframe location doesn't change.
     */
    const iframe = window.frames['nativeIframeOne'];
    if (iframe) {
      iframe.setAttribute?.('src', finalUrl);
      iframe.contentWindow?.location?.replace?.(finalUrl);
    }
  }, [streamUrl]);

  /**
   * Runs whenever streamUrl changes. To load the corresponding clx version
   */
  useEffect(() => {
    renderIframe();
  }, [streamUrl, reloadState]);

  return isFullScreen ? (
    <div>
      <CoursePageIframe id="nativeIframeWrapper">
        <iframe
          src="about:blank"
          id="nativeIframeOne"
          webkitallowfullscreen="true"
          allowFullScreen="allowfullscreen"
          width="100%"
          height="100%"
          allow="autoplay; fullscreen; camera; microphone"
          frameBorder="no"
          title="Class"
        />
      </CoursePageIframe>
    </div>
  ) : null;
};

export default VideoFrame;

VideoFrame.propTypes = {
  classDetails: PropTypes.objectOf(PropTypes.any).isRequired,
  loggedInUser: PropTypes.objectOf(PropTypes.any),
  isFullScreen: PropTypes.bool,
  sendWatched: PropTypes.func.isRequired,
  sendWatchedPrevious: PropTypes.func.isRequired,
  accessToken: PropTypes.string,
  streamUrl: PropTypes.string.isRequired,
  showPlayer: PropTypes.bool,
  isUnacademyTeachClass: PropTypes.bool,
  reloadState: PropTypes.any
};

VideoFrame.defaultProps = {
  isFullScreen: false,
  showPlayer: false,
  loggedInUser: null,
  // setShowIframeHandler: null,
  isUnacademyTeachClass: false,
  reloadState: null,
  accessToken: null
};
